export default "__VITE_ASSET__BF6PPUSr__"